<script setup lang="ts">
  import type { ServicesSectionContent } from '@/models/service';
  import type { SwiperContainer } from 'swiper/element';
  import { ref, onMounted } from 'vue';
  import type { PropType } from 'vue';
  import ServiceCard from './ServiceCard.vue';
  import CustomServiceCard from './CustomServiceCard.vue';

  defineProps({
    servicesSectionContent: {
      type: Object as PropType<ServicesSectionContent>,
      required: true
    },
    localePath: {
      type: Function as PropType<(to: { name: string; params: { slug: string } }) => string>,
      required: true
    }
  });

  const emits = defineEmits(['contactClick']);

  const onContactClick = () => {
    emits('contactClick');
  };

  const swiperRef = ref<SwiperContainer | undefined>();

  onMounted(() => {
    if (swiperRef.value) {
      swiperRef.value.initialize();
      swiperRef.value?.classList.add('swiper-initialized');
    }
  });
</script>

<template>
  <div class="services-section__swiper">
    <swiper-container
      v-if="servicesSectionContent.useCases.length"
      ref="swiperRef"
      :slides-per-view="1"
      :space-between="16"
      :loop="true"
      :speed="1000"
      :pagination="true"
      :init="false">
      <swiper-slide
        v-for="(useCaseItem, index) in servicesSectionContent.useCases"
        :key="index">
        <ServiceCard
          :use-case-item="useCaseItem"
          :use-case-button-text="servicesSectionContent.useCaseButtonText"
          :locale-path="localePath" />
      </swiper-slide>
    </swiper-container>
    <CustomServiceCard
      :service-section-content="servicesSectionContent"
      @contact-click="onContactClick" />
  </div>
</template>
